module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/menu-bar-d6bff6ce5a58767d4749a67428fd7d03.svg";